module.exports = __webpack_public_path__ + "img/tmx-futar-logo.9fab23c3.png";